import React, { useMemo, type PropsWithChildren, createContext, useContext } from 'react';
import type { RenderChildRows } from '@atlassian/jira-issue-table-hierarchy/src/ui/types.tsx';
import type { Column, TableInjectedCellProps } from '../../../common/types.tsx';

export type Props = {
	columns: Column[];
	tableInjectedProps: TableInjectedCellProps;
	renderChildRows?: RenderChildRows;
	groupId?: string;
};

const RowContext = createContext<Props | null>(null);

export const useRowContext = (): Props => {
	const context = useContext(RowContext);

	if (!context) {
		throw new Error('useRowContext must be used within RowContextProvider');
	}

	return context;
};

export const RowContextProvider = ({
	children,
	columns,
	tableInjectedProps,
	renderChildRows,
	groupId,
}: PropsWithChildren<Props>) => {
	const props = useMemo(
		() => ({
			columns,
			tableInjectedProps,
			renderChildRows,
			groupId,
		}),
		[columns, tableInjectedProps, renderChildRows, groupId],
	);

	return <RowContext.Provider value={props}>{children}</RowContext.Provider>;
};
